(function ($) {

  Drupal.behaviors.THEMESlickConfig = {
    attach: function (context, settings) {

      // $(".slick_carousel__items").slick({
      //   dots: false,
      //   infinite: true,
      //   speed: 1000,
      //   slidesToShow: 1,
      //   adaptiveHeight: false,
      //   prevArrow: '<i class="icon--chevron-left site__section-about--jump-l"></i>',
      //   nextArrow: '<i class="icon--chevron-right site__section-about--jump-r"></i>',
      // });

      $(".blog__gallery.slick_carousel__items_gallery").slick({
        dots: true,
        rows: 2,
        slidesPerRow: 2,
        centerMode: true,
        variableWidth: true,
        infinite: false,
        speed: 500,
        adaptiveHeight: false,
        prevArrow: '<i class="icon--chevron-left site__section-blog--jump-l"></i>',
        nextArrow: '<i class="icon--chevron-right site__section-blog--jump-r"></i>',
        responsive: [{
          breakpoint: 480,
          settings: {
            slidesPerRow: 2,
            centerMode: false,
            variableWidth: false,
            variableHeight: true,
          }
        }]
      });

    }
  };

})(jQuery);
